import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

const Tfail = (props) => {
  const { apiUrl, history } = props;
  let orderId = new URL(window.location.href).searchParams.get('orderId');
  let code = new URL(window.location.href).searchParams.get('code');
  let message = new URL(window.location.href).searchParams.get('message');

  const _callApi = async () => {
    const result = await axios.post(apiUrl + '/exhibitionPayError', {
      orderId,
      code,
      message,
    });

    const intReturn = result.data[0].intReturn;

    // if (intReturn === 0) {
    // alert(`결제도중 오류가 발생했습니다.\n${message}`);
    history.push('/reserveFail?orderCode=' + orderId + '&message=' + message);
    // }
  };

  useEffect(() => {
    _callApi();
  }, []);

  return <div style={{ color: '#fff' }}>{message}</div>;
};

export default shopContext(withRouter(Tfail));
